import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  root: {
    color: custom.grey[4],
    fontSize: 12,
    whiteSpace: 'nowrap',
  },
}));
